import { Brain } from 'lucide-react';
import type { ModuleMeta } from '../types';

export const meta: ModuleMeta = {
  id: 'memory',
  label: 'Memory',
  route: '/memory',
  icon: Brain,
};
